import { SubAgent, UserInfo } from '@/models/sub-agent';

export class SellerModel {
  id: number;
  codiceVenditore: string;
  descrizione: string;
  marca: string;
  tipoVenditore: string;
  agenziaSubagente: SubAgent;
  user: UserInfo;
  users: UserInfo[] = [];
  enabled: boolean;
}
